type OptionsListProps = { children: React.ReactNode };

const OptionsList = ({ children }: OptionsListProps) => {
	return (
		<div
			className={`skuSelectorOptionsList vtex-store-components-3-x-skuSelectorOptionsList w-100 inline-flex flex-wrap ml2 items-center`}
		>
			{children}
		</div>
	);
};

export default OptionsList;
